import React from "react";
import { Container, Eyebrow } from "../components/primitives";

// Logos self-hosted from Simple Icons (CC0). Brands without an available icon render as a typographic wordmark.
const CLIENTS = [
  { name: "Accenture", logo: "/clients/accenture.svg" },
  { name: "HCL Technologies", logo: "/clients/hcl.svg" },
  { name: "Cognizant" },
  { name: "Mphasis" },
  { name: "Infosys", logo: "/clients/infosys.svg" },
  { name: "Wipro", logo: "/clients/wipro.svg" },
  { name: "Deloitte" },
  { name: "Microsoft" },
  { name: "Capgemini" },
  { name: "NTT DATA" },
  { name: "DXC Technology" },
  { name: "Thoughtworks" },
  { name: "Coforge" },
  { name: "Hexaware" },
  { name: "Virtusa" },
  { name: "Zensar", logo: "/clients/zensar.svg" },
  { name: "Sonata Software" },
  { name: "Birlasoft" },
  { name: "Motherson" },
  { name: "LTIMindtree" },
  { name: "EY" },
  { name: "Tech Mahindra" },
  { name: "Persistent Systems", logo: "/clients/persistent.svg" },
  { name: "TCS", logo: "/clients/tcs.svg" },
  { name: "IBM" },
  { name: "Oracle" },
  { name: "Amazon" },
  { name: "Google", logo: "/clients/google.svg" },
  { name: "SAP", logo: "/clients/sap.svg" },
  { name: "Salesforce" },
];

function ClientCard({ c }) {
  return (
    <div className="client-logo" data-testid={`client-logo-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} title={c.name}>
      {c.logo ? (
        <img src={c.logo} alt={c.name} loading="lazy" />
      ) : (
        <span className="client-wordmark" aria-label={c.name}>{c.name}</span>
      )}
    </div>
  );
}

export default function Clients() {
  return (
    <section className="clients-section" id="clients" data-testid="clients-section" aria-labelledby="clients-heading">
      <Container>
        <div className="max-w-2xl mx-auto text-center">
          <Eyebrow className="justify-center">Our clients</Eyebrow>
          <h2 id="clients-heading" className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] text-[#0A1628]">
            Trusted by <span className="text-[#1A6EFF]">Leading Companies</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">We are proud to work with innovative organizations across technology, consulting, finance and enterprise.</p>
        </div>
      </Container>
      <div className="clients-carousel mt-14" role="region" aria-label="Client logos">
        <div className="clients-track" data-testid="clients-track">
          {CLIENTS.map((c) => <ClientCard key={c.name} c={c} />)}
          {CLIENTS.map((c) => <ClientCard key={`${c.name}-dup`} c={{ ...c, name: c.name }} />)}
        </div>
      </div>
      <div className="clients-trust">
        <span className="trust-line" /><span>Trusted partnerships. Proven expertise. Lasting results.</span><span className="trust-line" />
      </div>
    </section>
  );
}
